export function onSlide(element, idx, max_idx){
    const width = Math.ceil(1 / max_idx * 100) + "%";
    const left = Math.ceil(idx / max_idx * 100) + "%";

    $(element).find(".active-bar").css("width", width).css("left", left);
}